import * as React from 'react';
import {connect} from 'react-redux';
import {withTranslation} from 'react-i18next';
import VehiclesList from './../Map/VehiclesList/VehiclesList';
import FleetList from 'components/Fleet/FleetList';
import ZonesList from 'components/Zones/ZonesList';
import * as ViewManagementModule from 'Modules/ViewManagementModule';

type ConnectedProps = {
    viewManagementStore: ViewManagementModule.Types.ViewManagementStore;
    t?: (key: string) => string;
};

type DispatchedProps = {
    showVehicleList: () => void;
    hideVehicleList: () => void;
    changeAlertListType: (type: ViewManagementModule.Types.AlertListTypeVisible) => void;
};

type P = {
    match: any;
};

type S = {};

class CompositeLists extends React.Component<P & ConnectedProps & DispatchedProps, S> {
    constructor(props: P & ConnectedProps & DispatchedProps) {
        super(props);
    }

    public render() {
        const {vehicleListVisible, alertListTypeVisible} = this.props.viewManagementStore;
        const {t, changeAlertListType, hideVehicleList, showVehicleList} = this.props;

        return (
            <div className="table__bottom">
                <div className={`table-toggle ${vehicleListVisible ? 'table-toggle--open' : ''}`}
                     onClick={() => (vehicleListVisible ? hideVehicleList() : showVehicleList())}>
                    <div
                        className={`cell__expander cell__expander--white ${vehicleListVisible ? 'cell__expander--expanded' : ''}`}/>
                </div>
                {vehicleListVisible && (
                    <>
                        <div className="table-type-selector">
                            <div
                                className={`table-type-selector__option ${alertListTypeVisible === 'cars' ? 'table-type-selector__option--active' : ''}`}
                                onClick={() => changeAlertListType('cars')}>
                                {t('cars')}
                            </div>
                            <div
                                className={`table-type-selector__option ${alertListTypeVisible === 'fleets' ? 'table-type-selector__option--active' : ''}`}
                                onClick={() => changeAlertListType('fleets')}>
                                {t('fleets')}
                            </div>
                            <div
                                className={`table-type-selector__option ${alertListTypeVisible === 'zones' ? 'table-type-selector__option--active' : ''}`}
                                onClick={() => changeAlertListType('zones')}>
                                {t('zones')}
                            </div>
                        </div>
                        <div
                            className={`table__content table__content--with-options ${vehicleListVisible ? 'table__content--expanded' : 'table__content--hidden'}`}>
                            {alertListTypeVisible === 'cars' && <VehiclesList tableOnly match={this.props.match}/>}
                            {alertListTypeVisible === 'fleets' && <FleetList tableOnly match={this.props.match}/>}
                            {alertListTypeVisible === 'zones' && <ZonesList tableOnly match={this.props.match}/>}
                        </div>
                    </>
                )}
            </div>
        );
    }
}

function mapStateToProps(state: any): ConnectedProps {
    return {
        viewManagementStore: state.viewManagementStore
    };
}

function mapDispachToProps(dispatch: any): DispatchedProps {
    return {
        showVehicleList: () => dispatch(ViewManagementModule.Actions.showVehicleList()),
        hideVehicleList: () => dispatch(ViewManagementModule.Actions.hideVehicleList()),
        changeAlertListType: (type: ViewManagementModule.Types.AlertListTypeVisible) => dispatch(ViewManagementModule.Actions.changeAlertListType(type))
    };
}

export default withTranslation('carDetails')(
    connect(
        mapStateToProps,
        mapDispachToProps
    )(CompositeLists) as React.ComponentType<any>
);



// WEBPACK FOOTER //
// ./src/components/Alerts/CompositeLists.tsx